import { saveAs } from "file-saver";

/**
 * Have the user's browser download a blog as a file instantly.
 *
 * @param {Blob} blobData 
 * @param {string} name
 * @return {Promise<void>}
 */
export async function downloadBlob(blobData, name, type = "application/pdf") {
    const url = window.URL.createObjectURL(
        new Blob([blobData], { type })
    );
    return saveAs(url, name);
}


// WEBPACK FOOTER //
// ./src/utilities/download-blob.js